(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- boot sequence ---------- */
  function boot() {
    var el = document.querySelector('[data-boot]');
    if (!el) return;
    if (reduced) { el.remove(); return; }
    var bars = el.querySelector('[data-boot-bar]');
    var pct = el.querySelector('[data-boot-pct]');
    var lines = el.querySelectorAll('[data-boot-line]');
    var i = 0;
    document.body.style.overflow = 'hidden';
    var step = setInterval(function () {
      i++;
      lines.forEach(function (l, n) { if (n < i) l.style.opacity = '1'; });
      if (bars) bars.style.width = (i / lines.length) * 100 + '%';
      if (pct) pct.textContent = Math.round((i / lines.length) * 100) + '%';
      if (i >= lines.length) {
        clearInterval(step);
        setTimeout(function () {
          el.style.opacity = '0';
          document.body.style.overflow = '';
          setTimeout(function () { el.remove(); }, 600);
        }, 500);
      }
    }, 480);
  }

  /* ---------- reveal on scroll ---------- */
  function reveals() {
    var els = document.querySelectorAll('[data-reveal]');
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { e.classList.add('reveal'); io.observe(e); });
  }

  /* ---------- 3D tilt cards ---------- */
  function tilt() {
    if (reduced) return;
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      var wrap = card.closest('.tilt-wrap') || card;
      wrap.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'rotateX(' + (-py * 9) + 'deg) rotateY(' + (px * 9) + 'deg)';
        card.style.setProperty('--px', px.toFixed(3));
        card.style.setProperty('--py', py.toFixed(3));
      });
      wrap.addEventListener('mouseleave', function () {
        card.style.transform = 'rotateX(0) rotateY(0)';
        card.style.setProperty('--px', '0'); card.style.setProperty('--py', '0');
      });
    });
  }

  /* ---------- route mesh edges + hover link ---------- */
  function mesh() {
    var svg = document.querySelector('[data-mesh]');
    if (!svg) return;
    var nodes = [].slice.call(svg.querySelectorAll('.mesh-node'));
    var edgesG = svg.querySelector('[data-mesh-edges]');
    if (!nodes.length || !edgesG) return;
    var pts = nodes.map(function (n) {
      return { el: n, id: n.getAttribute('data-id'), x: +n.getAttribute('data-x'), y: +n.getAttribute('data-y') };
    });
    var NS = 'http://www.w3.org/2000/svg';
    var edges = [];
    // chain + nearest extra link
    for (var i = 0; i < pts.length; i++) {
      var a = pts[i], b = pts[(i + 1) % pts.length];
      edges.push([a, b]);
      // nearest non-adjacent
      var best = null, bd = 1e9;
      for (var j = 0; j < pts.length; j++) {
        if (j === i || j === (i + 1) % pts.length) continue;
        var d = Math.hypot(pts[j].x - a.x, pts[j].y - a.y);
        if (d < bd) { bd = d; best = pts[j]; }
      }
      if (best && i % 2 === 0) edges.push([a, best]);
    }
    edges.forEach(function (e, idx) {
      var ln = document.createElementNS(NS, 'line');
      ln.setAttribute('x1', e[0].x); ln.setAttribute('y1', e[0].y);
      ln.setAttribute('x2', e[1].x); ln.setAttribute('y2', e[1].y);
      ln.setAttribute('stroke', 'rgba(120,165,220,0.28)');
      ln.setAttribute('stroke-width', '0.3');
      ln.setAttribute('vector-effect', 'non-scaling-stroke');
      ln.setAttribute('data-edge', e[0].id + '|' + e[1].id);
      if (!reduced) {
        ln.setAttribute('pathLength', '1');
        ln.style.strokeDasharray = '1'; ln.style.strokeDashoffset = '1';
        ln.style.animation = 'draw 1.2s ease forwards'; ln.style.animationDelay = (0.3 + idx * 0.08) + 's';
      }
      edgesG.appendChild(ln);
    });

    function setActive(id, on) {
      svg.querySelectorAll('[data-edge]').forEach(function (ln) {
        var live = ln.getAttribute('data-edge').indexOf(id) !== -1;
        if (live) {
          ln.setAttribute('stroke', on ? 'rgba(98,191,245,0.9)' : 'rgba(120,165,220,0.28)');
          ln.setAttribute('stroke-width', on ? '0.55' : '0.3');
        }
      });
      var card = document.querySelector('[data-node="' + id + '"] [data-tilt]');
      if (card) card.style.borderColor = on ? 'rgba(98,191,245,0.55)' : '';
    }

    pts.forEach(function (p) {
      p.el.addEventListener('mouseenter', function () { setActive(p.id, true); });
      p.el.addEventListener('mouseleave', function () { setActive(p.id, false); });
      p.el.addEventListener('click', function () { var u = p.el.getAttribute('data-url'); if (u) window.location.href = u; });
    });
    // card -> node
    document.querySelectorAll('[data-node]').forEach(function (card) {
      var id = card.getAttribute('data-node');
      card.addEventListener('mouseenter', function () { setActive(id, true); });
      card.addEventListener('mouseleave', function () { setActive(id, false); });
    });
  }

  /* ---------- tier filter ---------- */
  function filters() {
    var bar = document.querySelector('[data-filters]');
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var f = btn.getAttribute('data-filter');
      bar.querySelectorAll('[data-filter]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      document.querySelectorAll('[data-card]').forEach(function (card) {
        var show = f === 'all' || card.getAttribute('data-tier') === f;
        card.style.display = show ? '' : 'none';
      });
    });
  }

  /* ---------- AJAX add to cart ---------- */
  function cart() {
    document.querySelectorAll('form.pp-add').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Routing…'; }
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[name=id]').value, quantity: 1 })
        }).then(function (r) { return r.json(); }).then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        }).then(function (c) {
          document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
          var link = document.querySelector('[data-cart-link]');
          if (link) { link.classList.add('cart-bump'); setTimeout(function () { link.classList.remove('cart-bump'); }, 450); }
          if (btn) { btn.textContent = 'Cached ✓'; setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1200); }
        }).catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
      });
    });
  }

  /* ---------- countdown ---------- */
  function countdown() {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var target = new Date(el.getAttribute('data-target')).getTime();
    if (isNaN(target)) return;
    function tick() {
      var ms = Math.max(0, target - Date.now());
      var d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24,
          m = Math.floor(ms / 60000) % 60, s = Math.floor(ms / 1000) % 60;
      var map = { days: d, hrs: h, min: m, sec: s };
      Object.keys(map).forEach(function (k) {
        var u = el.querySelector('[data-unit=' + k + ']');
        if (u) u.textContent = ('0' + map[k]).slice(-2);
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- faq accordion ---------- */
  function accordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (acc) {
      var btn = acc.querySelector('[data-acc-toggle]');
      var panel = acc.querySelector('[data-acc-panel]');
      var icon = acc.querySelector('[data-acc-icon]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = panel.style.gridTemplateRows !== '1fr';
        panel.style.gridTemplateRows = open ? '1fr' : '0fr';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (icon) { icon.style.transform = open ? 'rotate(45deg)' : 'none'; icon.style.color = open ? 'var(--cyan)' : ''; }
      });
    });
  }

  ready(function () {
    boot(); reveals(); tilt(); mesh(); filters(); cart(); countdown(); accordions();
  });
})();
